import { createContext, useState } from "react";
import { NominaProvider } from "./NominProvider";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    const [persist, setPersist] = useState(JSON.parse(localStorage.getItem("persist")) || true);
    console.log(auth);
    return (
        
        <AuthContext.Provider value={{ auth, setAuth, persist, setPersist }}>
            <NominaProvider>
            {children}
            </NominaProvider>
        </AuthContext.Provider>
    )
}

export default AuthContext;